import { motion } from "framer-motion";
import { ArrowUpRight, Cpu, Zap, Waves } from "lucide-react";

const FEATURES = [
  { icon: Cpu, text: "Individuelle Poolsteuerung — in unserem Haus entwickelt" },
  { icon: Zap, text: "Integrierte Elektrik — Technik & Strom aus einem Guss" },
  { icon: Waves, text: "Kristallklare Wasseraufbereitung — nachgerüstet im Bestand" },
];

export default function RevivoSection() {
  const openRevivo = () => window.open("https://revivo-smartpool.de/", "_blank", "noopener");

  return (
    <section id="revivo" data-testid="revivo-smartpool-section" className="relative py-20 sm:py-28 bg-[#07101D] overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="text-xs uppercase tracking-[0.32em] font-mono text-cyan-400 font-semibold">
            Modernisierung für Bestandspools
          </p>
          <h2 className="mt-4 font-medium tracking-tight leading-tight text-3xl sm:text-5xl text-white">
            <span className="notranslate" translate="no">REVIVO-Smartpool</span> — Ihr alter Pool.{" "}
            <span className="italic text-cyan-300">Neue Technik. Zweites Leben.</span>
          </h2>
          <p className="mt-5 text-slate-300/90 text-sm sm:text-base leading-relaxed font-light max-w-xl">
            Das Technik-Upgrade der <span className="notranslate" translate="no">coolpool company</span>:
            individuelle Poolsteuerung, integrierte Elektrik und kristallklare Wasseraufbereitung —
            nachgerüstet in Ihren bestehenden Pool, ohne das Becken aufzureißen.
          </p>
          <ul className="mt-7 space-y-3.5">
            {FEATURES.map((f) => {
              const Icon = f.icon;
              return (
                <li key={f.text} className="flex items-center gap-3.5 text-sm text-slate-200">
                  <span className="w-9 h-9 rounded-xl bg-cyan-400/10 border border-cyan-400/30 flex items-center justify-center shrink-0">
                    <Icon className="w-4 h-4 text-cyan-300" />
                  </span>
                  {f.text}
                </li>
              );
            })}
          </ul>
          <div className="mt-9 flex flex-wrap items-center gap-4">
            <button
              data-testid="revivo-external-link-button"
              onClick={openRevivo}
              className="cyan-glow-btn text-[#050B14] font-semibold px-7 py-4 rounded-full inline-flex items-center gap-2 text-sm sm:text-base"
            >
              Kostenlosen Pool-Check starten <ArrowUpRight className="w-4 h-4" />
            </button>
            <p className="text-xs font-mono text-slate-500">revivo-smartpool.de</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <div className="spotlight-img relative rounded-2xl overflow-hidden border border-white/10 shadow-[0_40px_100px_-30px_rgba(0,229,255,0.2)]">
            <img
              src="https://revivo-smartpool.de/images/pooltechnik-box.webp"
              alt="REVIVO-Smartpool Pooltechnik-Box mit Steuerung am Pool"
              className="w-full aspect-[4/3] object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050B14]/70 via-transparent to-transparent" />
            <span className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.22em] font-mono font-bold bg-[#050B14]/75 backdrop-blur px-3.5 py-1.5 rounded-full border border-cyan-400/30 text-cyan-300 notranslate" translate="no">
              REVIVO-Smartpool
            </span>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="absolute -bottom-7 -left-4 sm:-left-8 glass-card rounded-2xl p-5 bg-[#0A1526]/90 max-w-[240px]"
          >
            <div className="font-display font-semibold text-2xl text-cyan-300">2 Min.</div>
            <div className="text-xs text-slate-400 mt-1 leading-relaxed">
              Online Pool-Check — kostenlos und unverbindlich, Antwort mit erster Einschätzung.
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
